const globalInitialState = {
    visitedList: null,
    locationDetail: null,
    locationStoreTime: null,
    footerLocations: null,
    footerLocationStoreTime: null,
    searchHistory:[],
    availablity:null

};
export default globalInitialState;